import { z } from "zod";
import { MetaSchema } from "./shared";

export const tradeDepositItemSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.union([z.string(), z.number()]).nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  created_at: z.string(),
  completedAt: z.string().nullable(),
  status: z.string(),
  description: z.string().nullable(),
});

const getTradeTurnoverDepositSchema = z.object({
  data: z.tuple([z.array(tradeDepositItemSchema), z.number()]),
  meta: MetaSchema.default,
});

export type GetTradeTurnoverDepositResponse = z.infer<
  typeof getTradeTurnoverDepositSchema
>;
export type TradeDepositItem = z.infer<typeof tradeDepositItemSchema>;

export default getTradeTurnoverDepositSchema